import { SET_DAILY_MENU, SET_FULL_MENU } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getDailyMenu = (date) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/menus/daily?date=${date}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_DAILY_MENU, payload: response.data.menu });
    }
    catch (error) { errorHandler(error, null); }
};

export const getFullMenu = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/menus`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_FULL_MENU, payload: response.data.menu });
    }
    catch (error) { errorHandler(error, null); }
};

export const newMenu = (formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/menus`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editMenu = (menuID, formValues, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/menus/${menuID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const confirmMenu = (menuID) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/menus/confirm/${menuID}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};